// tslint:disable
/**
 * Projecto API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CostCreateCommandFromJSON(json) {
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'costId': !exists(json, 'costId') ? undefined : json['costId'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'budgetId': !exists(json, 'budgetId') ? undefined : json['budgetId'],
        'costTypeInput': !exists(json, 'costTypeInput') ? undefined : json['costTypeInput'],
        'itemDate': !exists(json, 'itemDate') ? undefined : new Date(json['itemDate']),
        'dateEntered': !exists(json, 'dateEntered') ? undefined : new Date(json['dateEntered']),
        'reqNum': !exists(json, 'reqNum') ? undefined : json['reqNum'],
        'reqDate': !exists(json, 'reqDate') ? undefined : new Date(json['reqDate']),
        'commitNum': !exists(json, 'commitNum') ? undefined : json['commitNum'],
        'commitLineNum': !exists(json, 'commitLineNum') ? undefined : json['commitLineNum'],
        'vendorCode': !exists(json, 'vendorCode') ? undefined : json['vendorCode'],
        'acctNumber': !exists(json, 'acctNumber') ? undefined : json['acctNumber'],
        'coNum': !exists(json, 'coNum') ? undefined : json['coNum'],
        'glCode': !exists(json, 'glCode') ? undefined : json['glCode'],
        'vendorInvoiceNum': !exists(json, 'vendorInvoiceNum') ? undefined : json['vendorInvoiceNum'],
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : new Date(json['invoiceDate']),
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
        'pjtNumber': !exists(json, 'pjtNumber') ? undefined : json['pjtNumber'],
        'pjtMgr': !exists(json, 'pjtMgr') ? undefined : json['pjtMgr'],
    };
}
export function CostCreateCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'costId': value.costId,
        'projectId': value.projectId,
        'budgetId': value.budgetId,
        'costTypeInput': value.costTypeInput,
        'itemDate': value.itemDate === undefined ? undefined : value.itemDate.toISOString(),
        'dateEntered': value.dateEntered === undefined ? undefined : value.dateEntered.toISOString(),
        'reqNum': value.reqNum,
        'reqDate': value.reqDate === undefined ? undefined : value.reqDate.toISOString(),
        'commitNum': value.commitNum,
        'commitLineNum': value.commitLineNum,
        'vendorCode': value.vendorCode,
        'acctNumber': value.acctNumber,
        'coNum': value.coNum,
        'glCode': value.glCode,
        'vendorInvoiceNum': value.vendorInvoiceNum,
        'invoiceDate': value.invoiceDate === undefined ? undefined : value.invoiceDate.toISOString(),
        'amount': value.amount,
        'description': value.description,
        'comments': value.comments,
        'pjtNumber': value.pjtNumber,
        'pjtMgr': value.pjtMgr,
    };
}
